import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	chatHistorySidebarState: "open-sb", // Default state
};

const chatHistorySidebarSlice = createSlice({
	name: "chatHistorySidebar",
	initialState,
	reducers: {
		toggleChatHistorySidebar: (state) => {
			state.chatHistorySidebarState = state.chatHistorySidebarState === "open-sb" ? "minimize-sb" : "open-sb";
		},
	},
});

export const { toggleChatHistorySidebar } = chatHistorySidebarSlice.actions;
export default chatHistorySidebarSlice.reducer;